class Load3rdPartyScripts{

    static Stripe( ) {
        var ref = window.document.getElementsByTagName( 'script' )[ 0 ];
        var scriptStripe = window.document.createElement( 'script' );
        scriptStripe.defer = true
        scriptStripe.src = 'https://js.stripe.com/v3/';

        ref.parentNode.insertBefore( scriptStripe, ref );
    }

    static GoogleMaps( ) {
        var ref = window.document.getElementsByTagName( 'script' )[ 0 ];
        var scriptGMap = window.document.createElement( 'script' );
        scriptGMap.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyD0oY_pRWbcmkuz94H9QK7JPwTfpjhOS2I&libraries=places,geometry,drawing&componentRestrictions=country:mx';
        ref.parentNode.insertBefore( scriptGMap, ref );
    }

    static GoogleFonts( ) {
        var ref = window.document.getElementsByTagName( 'script' )[ 0 ];
        var linkFont = window.document.createElement( 'link' );
        linkFont.rel = 'stylesheet'
        linkFont.href = 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap';
        ref.parentNode.insertBefore( linkFont, ref );
    }

    static Tidio( ) {
        // var ref = window.document.getElementsByTagName( 'script' )[ 0 ];
        // var scriptTidio = window.document.createElement( 'script' );
        // scriptTidio.defer = true
        // scriptTidio.src = '//code.tidio.co/4srehgiq1pugq4z4hybf0tdbbolotrww.js';
        // ref.parentNode.insertBefore( scriptTidio, ref );
    }

}

export default Load3rdPartyScripts